"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.conditionalStyles = conditionalStyles;

function conditionalStyles(propKey, styleMap) {
  return function (props) {
    return styleMap[props[propKey]];
  };
}